---
title: "Receiving a Package"
slug: scanning-a-package
description: "Step-by-step guide for receiving a returned package by camera scan or manual GRAI entry."
keywords:
  - receive
  - scan
  - package
  - GRAI
  - camera
  - recent activity
  - scanner
---

## Prerequisites

- Role: Scanner, Manager, or Company Admin
- At least one internal location must be assigned to your account
- The package must carry a valid GRAI identifier

## Steps

1. Navigate to **Receive** in the top menu.
2. Select your current location from the **Scan Location** dropdown.
3. Point the camera at the QR code on the package. The scan starts automatically once the code is detected.
   - Alternatively: click **Enter Package ID** to type or paste the GRAI manually.
4. Optionally add a short note under **Additional Information**, such as the condition on arrival.
5. Click **Record Scan** to confirm receipt.
6. The scan appears immediately under **Recent Activity** in the scanner area.

## If something goes wrong

- **"Package not found"** — The GRAI may not be registered yet. Use the **Register as new package** function to create it.
- **"Invalid GRAI format"** — Check that the entered code is complete (34 characters).
- **"You are not authorized to scan at this location"** — Your role does not allow scanning at this location. Contact your Company Admin.
- **Camera unavailable** — Check that your browser has camera permission. Use manual entry as an alternative.
- **Offline mode** — When offline, scans are stored locally and synchronised automatically once the connection is restored.
- Contact us: support@heycircle.com or use the feedback button in the bottom-right corner of the screen.

## Related Articles

- [Sending a Package](/app/help?article=sending-a-package)
- [Reporting a Defect](/app/help?article=reporting-a-defect)
- [Reading the Analytics Dashboard](/app/help?article=viewing-analytics)
